export class TrocaSenha{
    senhaAtual:string;
	senhaNova:string;
}